<template>
  <div class="card">
    <div class="card-body">
      <b-tabs v-model="tab">
        <b-tab   :title="$t('announcements.announcements')" >
          <data-table :edit-item="editItem" />
        </b-tab>
        <b-tab   :title="$t('site.add')">
          <my-form :new-item="newItem" />
        </b-tab>
      </b-tabs>
    </div>
    <!-- end of card body -->
  </div>
</template>

<script>
import DataTableVue from "./components/DataTable.vue";
import FormVue from "./components/Form.vue";

export default {
  name: "AnnouncementsIndex",
  components: {
    "data-table": DataTableVue,
    "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tab:0,
    };
  },
  created(){
    this.$mobileTitle.label=this.$i18n.t('announcements.announcements'); 

  },
  methods: {
    editItem(data) {
       this.newItem = data.item;
       this.tab=1;
    },
  },
};
</script>
